<template></template>

<script>
import {mapActions} from "vuex";

export default {
    name: 'init-store',
    props: ['initialData'],
    mounted() {
        this.$store.commit('INSERT_INITIAL_DATA', this.initialData)
        this.freshProducts()
    },
    methods: {
        ...mapActions(['freshProducts'])
    }
}
</script>
